import type React from "react";
import type { PropsWithChildren } from "react";
import { useAuthenticatedAuthContext } from "../auth/Auth.component";
import LinkWrapper from "./LinkWrapper";
import WidgetWrapper from "./WidgetWrapper";

const Wrapper: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
	const { selectedCompany, viewMode } = useAuthenticatedAuthContext();

	if (viewMode === "link") {
		return (
			<LinkWrapper selectedCompany={selectedCompany}>{children}</LinkWrapper>
		);
	}
	return <WidgetWrapper>{children}</WidgetWrapper>;
};

export default Wrapper;
